"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mura": {
    "25dffb9c": [{
      "hkey": "654df907",
      "slug": "mura",
      "name": "Mura",
      "primary": true,
      "skipSearch": false
    }],
    "cearina": [{
      "hkey": "654df907",
      "slug": "mura",
      "name": "Mura",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "508d02a2": [{
      "hkey": "654df907",
      "slug": "mura",
      "name": "Mura",
      "primary": true,
      "skipSearch": false
    }],
    "pendoline": [{
      "hkey": "654df907",
      "slug": "mura",
      "name": "Mura",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "49626347": [{
      "hkey": "654df907",
      "slug": "mura",
      "name": "Mura",
      "primary": true,
      "skipSearch": false
    }],
    "piani": [{
      "hkey": "654df907",
      "slug": "mura",
      "name": "Mura",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "296e137a": [{
      "hkey": "654df907",
      "slug": "mura",
      "name": "Mura",
      "primary": true,
      "skipSearch": false
    }],
    "torremmo": [{
      "hkey": "654df907",
      "slug": "mura",
      "name": "Mura",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;